import React, { useState, useEffect } from 'react'
import { Export, Import, LogisticsRoot } from '@/app/types/productServiceType'
import { productCountryCard } from '@/services/companyDetailsService'
import { useParams } from 'next/navigation'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import { useTranslation } from '@/app/i18n/client'
import { Skeleton } from '@/components/ui/skeleton'
import Image from 'next/image'

const LogisticsCard = ({ title }: { title: string }) => {
  const { t } = useTranslation()
  const [importCountry, setImportCountry] = useState<Import[]>([])
  const [exportCountry, setExportCountry] = useState<Export[]>([])
  const params = useParams()
  const [isloading, setIsLoading] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      const logisticsData: LogisticsRoot = await productCountryCard(params.id)
      if (logisticsData?.status === 'success') {
        setImportCountry(logisticsData?.logistics?.imports)
        setExportCountry(logisticsData?.logistics?.exports)
      }
      setIsLoading(false)
    }
    fetchData()
  }, [])
  return (
    <div>
      <div className=" shadow-[0_0_6px_0_rgba(0,0,0,0.11)]  mt-[20px]">
        <h1 className=" px-5 py-3 font-ns_bold text-base border-b border-solid border-[#eaeaea]">
          {t(title)}
        </h1>
        {!isloading ? (
          <div className="flex items-start mt-7 px-5 pb-9">
            <div className="w-[50%] ">
              <h1 className="font-ns_bold text-base">{t('Import From')}</h1>
              <div
                className={` mt-5 gap-2 w-fit ${importCountry?.length > 6 ? 'grid grid-cols-2' : 'flex flex-col'}`}
              >
                {importCountry?.length > 0 &&
                  importCountry.map((e: Import) => (
                    <CustomErrorBoundary key={e.id}>
                      <div
                        key={e.id}
                        className=" text-sm py-1 px-2 w-max text-primary-foreground rounded-full flex gap-1 bg-footer_color items-center justify-center"
                      >
                        <Image
                          loading="lazy"
                          width={15.7}
                          height={15.7}
                          className="rounded-full h-[15.7px] w-[15.7px] object-cover"
                          src={e.flag}
                          alt=""
                        />
                        {e.country}
                      </div>
                    </CustomErrorBoundary>
                  ))}
              </div>
            </div>
            <div className="w-[50%] ">
              <h1 className="font-ns_bold ">{t('Export To')}</h1>
              <div
                className={` mt-5 gap-2 w-fit ${exportCountry?.length > 6 ? 'grid grid-cols-2' : 'flex flex-col'}`}
              >
                {exportCountry?.length > 0 &&
                  exportCountry.map((e: Export) => (
                    <CustomErrorBoundary key={e.id}>
                      <div
                        key={e.id}
                        className=" text-sm py-1 px-2 w-max text-primary-foreground rounded-full flex gap-1 bg-footer_color items-center justify-center"
                      >
                        <Image
                          loading="lazy"
                          width={15.7}
                          height={15.7}
                          src={e.flag}
                          className="rounded-full  h-[15.7px] w-[15.7px] object-cover"
                          alt=""
                        />
                        <div className=" text-primary-foreground ">
                          {e.country}
                        </div>
                      </div>
                    </CustomErrorBoundary>
                  ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-start mt-7 px-5 pb-9 gap-5">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-40 " />
              <Skeleton className="h-4 w-20 " />
              <Skeleton className="h-4 w-20 " />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-40 " />
              <Skeleton className="h-4 w-20 " />
              <Skeleton className="h-4 w-20 " />
            </div>
          </div>
        )}
        {!isloading &&
          exportCountry?.length === 0 &&
          importCountry?.length === 0 && (
            <div className="p-16 flex flex-col gap-2 items-center justify-center text-primary-foreground">
              {t('Currently coverage areas are not available.')}
            </div>
          )}
      </div>
    </div>
  )
}

export default LogisticsCard
